export default __webpack_public_path__ + "static/media/din.689aea1b.jpeg";